<template>
                      <b-row>
                      <b-col xl="10" class="offset-xl-1">
                        <b-row>
                          <b-col>
                            <div class="how-to-page-header text-center mb-3">
                              <h1>
                                How To Use the
                                <span class="text-theme">MyBudgetReport</span>
                                Predictive Budgeting Application
                              </h1>
                              <p class="m-0"><em>Powered by SPENDiD</em></p>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Profile (Step 1)
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <h4 class="how-to-body-subtitle mb-4">
                                  Complete your 
                                  <b>“Peer Profile” </b> information by clicking
                                  on the <b><u>Start Interview </u></b> button and
                                  entering the requested information:
                                </h4>
                                <ul class="how-to-listing">
                                  <li>
                                    <b>5-digit Home Zip Code </b> where you live
                                    or may plan to live
                                  </li>
                                  <li>Your <b>Age</b></li>
                                  <li>
                                    <b># of Mouths to Feed </b> in your household
                                  </li>
                                  <li>
                                    Whether you <b>Rent or Buy </b> your home
                                  </li>
                                </ul>
                                <p>
                                  Click on the
                                  <span class="text-theme"><b>Next</b></span>
                                  button to proceed to the <b>Income</b> page.
                                </p>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Income (Step 2)
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <ul class="how-to-listing">
                                  <li>
                                    For each Income Source, choose either
                                    <b>Occupation</b> or <b>Manual Input</b>
                                    <ul class="how-to-listing">
                                      <li>
                                        For <b>Occupation</b> driven
                                        <b>Income</b> sources, click or type into
                                        the <b>Occupation Selector</b> field to
                                        choose from the list of tracked
                                        professions.
                                        <i
                                          >(this feature is helpful for student
                                          financial literacy and preparedness
                                          training, career counseling, etc..)</i
                                        >
                                      </li>
                                      <li>
                                        <p>
                                          For the chosen <b>Occupation</b>, select
                                          which
                                          <b>Annual Gross Salary Level</b> you
                                          want to use for your budget scenario.
                                          <i>(Low/Median/High)</i>
                                        </p>
                                        <p>
                                          This will automatically populate the
                                          <b>Annual Gross Salary</b> amount as
                                          well as the <b>Monthly Gross</b> and
                                          <b
                                            >Estimated Monthly Take Home Income</b
                                          >
                                          to be budgeted.
                                        </p>
                                      </li>
                                      <li>
                                        For <b>Manual Input</b> Income Sources,
                                        select <b>the Frequency </b>(how often)
                                        each income source is received.
                                      </li>
                                      <li>
                                        <p>
                                          For <b>Manual Input</b> Income Sources,
                                          enter the dollar <b>Amount</b> of Income
                                          for the <b>Frequency</b> selected, and
                                          indicate if the <b>Amount</b> is
                                          <b>Gross</b> or <b>Net “Take Home”</b>.
                                        </p>
                                        <p>
                                          <i
                                            >*These steps can be repeated for
                                            additional <b>Income Sources</b> by
                                            clicking on</i
                                          >
                                          <b> +Add More</b>
                                        </p>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                                <p>
                                  Click on the
                                  <span class="text-theme fw-700">Next</span>
                                  button to proceed to the <b>Expenses</b> page.
                                </p>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Expense Inputs (Step 3)
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <ul class="how-to-listing">
                                  <li>
                                    Enter a known
                                    <b>Monthly Rent or Mortgage Payment</b>
                                    (including Property Tax, Insurance, and any
                                    HOA dues). Optionally the user can
                                    <b>Use Peer Benchmark Amount</b> instead.
                                  </li>
                                  <li>
                                    Enter a known
                                    <b>Total Monthly Payments for All Vehicles</b
                                    >. Optionally the user can
                                    <b>Use Peer Benchmark Amount</b> instead.
                                  </li>
                                  <li>
                                    Enter a known monthly
                                    <b>Health Insurance Premium Amount</b> that is
                                    paid out of Take Home Income. Optionally the
                                    user can
                                    <b>Use Peer Benchmark Amount</b> instead. (But
                                    often this amount should be zero)
                                  </li>
                                  <li>
                                    Choose <b>Yes</b> or <b>No</b> to indicate if
                                    the user has
                                    <b>Other Monthly Debt Payments.</b>
                                    <ul class="how-to-listing">
                                      <li>
                                        <p>
                                          If <b>Yes</b> enter the
                                          <b>Monthly Payment Amount</b> for each
                                          type listed
                                        </p>
                                        <p>
                                          <i>(Note: Do NOT enter balance owed)</i>
                                        </p>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                                <p>
                                  Click on the
                                  <span class="text-theme"><b>FINISH</b></span>
                                  button to proceed to the <b>MyBudgetReport</b>
                                  application Dashboard.
                                </p>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  MyBudgetReport Application Dashboard
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <ul class="how-to-listing">
                                  <li>
                                    After completing the Profile, Income, and
                                    Expenses steps, the user lands on the
                                    <b>MyBudgetReport App</b> Dashboard with the
                                    <b>Results</b>
                                    section in view.
                                  </li>
                                  <li>
                                    The previous steps completed have populated
                                    all required fields of the <b>Profile</b> and
                                    <b>Major Expenses</b> Sections.
                                  </li>
                                  <li>
                                    Use the <b>Profile</b> or
                                    <b>Expenses</b> Section Headers at the top of
                                    the App to choose a section to view and
                                    potentially edit.
                                  </li>
                                  <li>
                                    Click on <b>Results</b> at any time to return
                                    to the full Application Dashboard.
                                  </li>
                                </ul>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Profile Section
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <p class="how-to-para">
                                  Users can click on <b>Profile</b> to review and
                                  edit any Peer <b>Profile</b> assumptions or
                                  <b>Income</b> amounts. Additional
                                  <b>Income Sources</b> can also be added.
                                </p>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Expenses Section
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <ul class="how-to-listing">
                                  <li>
                                    <h5 class="fw-700">Major Expenses</h5>
                                    These amounts have been populated already
                                    during the initial onboarding steps. You can
                                    edit them here at any time.
                                  </li>
                                  <li>
                                    <h5 class="fw-700">Monthly Bills</h5>
                                    <h6>
                                      Edit amounts for any of the six categories
                                      of common <b>Monthly Bills</b>
                                    </h6>
                                    <ul class="how-to-listing mt-3">
                                      <li>
                                        You may know a more accurate amount than
                                        MyBudgetReport’s peer predicted figure.
                                      </li>
                                      <li>
                                        For example, your Utilities-Power Bill
                                        might be a known amount different from
                                        what MyBudgetReport has forecasted. Just
                                        click that <b>Expense Tile</b> and enter
                                        your preferred amount, and MyBudgetReport
                                        will use it in all other calculations.
                                        (Your input amounts will appear as light
                                        blue bars)
                                      </li>
                                      <li>
                                        Based on your <b>Profile</b> and known
                                        <b>Expense Inputs</b>,
                                        <b>MyBudgetReport</b> calculates proposed
                                        budget amounts for all Expense Categories
                                        for which you did <b><u>NOT</u></b> input
                                        a known amount.
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <h5 class="fw-700">Other Expenses</h5>
                                    <h6>
                                      Same logic as for common
                                      <b>Monthly Bills</b> section
                                    </h6>
                                    <ul class="how-to-listing mt-3">
                                      <li>
                                        <b>Remove</b> any
                                        <b>Other Expense</b> categories that don't
                                        apply to you.
                                      </li>
                                      <li>
                                        You can easily Restore a Removed Category
                                        at any time from the <b
                                          >Removed Categories</b
                                        > section.
                                      </li>
                                      <li>
                                        Edit any of these
                                        <b>Other Expenses</b> categories to a
                                        Fixed Amount you know to be more accurate
                                        for you.
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Results
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <h4 class="how-to-body-subtitle mb-4">
                                  Once you've completed these simple steps, it's
                                  time to review your Results.
                                </h4>
                                <ul class="how-to-listing">
                                  <li>
                                    Your
                                    <b>Monthly Predicted Saving Ability</b> is
                                    critically important to know and understand.
                                    This is MyBudgetReport’s estimate of the
                                    potential monthly surplus (or shortfall) you
                                    are likely to experience over time.
                                  </li>
                                  <li>
                                    Your <b>SPENDiD Budget Health Score</b> is an
                                    easy-to-understand “grade” of your monthly
                                    cash flow health. This <b>Score</b> is also a
                                    powerful decision-making metric that can help
                                    you understand the level of budget stress a
                                    potential expense commitment might cause.
                                  </li>
                                  <li>
                                    This <b>SPENDiD Budget Health Score</b> is
                                    calculated based on your
                                    <b>Take Home Income</b> and
                                    <b>Monthly Predicted Saving Ability</b>.
                                  </li>
                                  <li>
                                    Built on the familiar 1-100 and grades of A-F
                                    that everyone understands, obviously the
                                    higher your <b>SPENDiD Budget Health Score</b
                                    > the better.
                                  </li>
                                  <li>
                                    The scale of the
                                    <b>SPENDiD Budget Health Score</b> is built
                                    such that a score of exactly 80 indicates a
                                    break-even level, or zero dollars of
                                    <b>Monthly Predicted Saving Ability</b>.
                                  </li>
                                  <li>
                                    A score above 80 indicates you should be able
                                    to have positive cash flow and an ability to
                                    add to savings or to reduce debt during most
                                    months.
                                  </li>
                                </ul>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Actions You Can Take
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <h5 class="mb-3 mb-lg-4">
                                  With these simple metrics and unique insights
                                  from your <b>Results:</b>
                                </h5>
                                <ul class="how-to-listing">
                                  <li>
                                    If you have a strong <b
                                      >SPENDiD Budget Health Score</b
                                    >, can you increase your
                                    <b>Amount to Savings</b> and start an
                                    automated draft to a separate emergency fund
                                    account? Or maybe it’s time to increase your
                                    401(k) with holding?
                                  </li>
                                  <li>
                                    If your <b>SPENDiD Budget Health Score</b
                                    > seems much lower than you expected,
                                    <ul class="how-to-listing">
                                      <li>
                                        First be sure you’ve entered your Profile,
                                        Income and Major Expenses information
                                        correctly.
                                      </li>
                                      <li>
                                        Have you removed any expense categories
                                        that don’t apply to you? For example, if
                                        your share of Health Insurance premiums is
                                        already deducted from your paycheck, you
                                        should be sure to zero out the amount for
                                        this expense category. Don’t have a pet?
                                        Then remove that category, and so on.
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    If you’ve entered a known fixed amount for
                                    any common <b>Monthly Bills</b> or <b
                                      >Other Expense Category</b
                                    >, be sure you entered the amount correctly
                                    and with the right payment <b>Frequency</b>.
                                  </li>
                                  <li>
                                    Next, are any of the Fixed Expenses you’ve
                                    input higher than your peers? These are shown
                                    in the <b>Opportunities</b> section.
                                    <ul class="how-to-listing">
                                      <li>
                                        Click on any of these <b
                                          >“Opportunity” bars</b
                                        > which will take you to that Expense
                                        tile. If the amount you have input is
                                        correct, click on the <b>“Ideas”</b
                                        > button. This will generate helpful
                                        information on that specific topic.
                                      </li>
                                      <li>
                                        For example, if your Rent is much higher
                                        than your peers, is it time to consider a
                                        lower-cost home or apartment, take in a
                                        roommate for a while to share expenses. If
                                        your Car Payments category is higher than
                                        your peers , is it time to get out from
                                        under that new truck payment you regret?
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Your Budget Model (50-30-20)
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <h5 class="mb-3 mb-lg-4">
                                  With these simple metrics and unique insights
                                  from your Results:
                                </h5>
                                <ul class="how-to-listing">
                                  <li>
                                    <b>50%</b> Toward <b>Needs -</b> This budget
                                    approach states that you should try to spend
                                    no more than 50% of your Take Home Income on
                                    “necessary items”. The items in this group of
                                    <b>Needs</b> cover the very basics of life
                                    including things such as
                                    <ul class="how-to-listing">
                                      <li>Housing</li>
                                      <li>
                                        Transportation, <b
                                          >including car payments and gas</b
                                        >
                                      </li>
                                      <li>
                                        Utilities, <b
                                          >like your cell phone, heat, water, gas
                                          and trash</b
                                        >
                                      </li>
                                      <li>
                                        Groceries <b
                                          >(but not eating out in restaurants)</b
                                        >
                                      </li>
                                      <li>
                                        Insurance premiums, <b
                                          >such as life insurance, health
                                          insurance and auto insurance</b
                                        >
                                      </li>
                                      <li>Medical bills</li>
                                      <li>Childcare</li>
                                      <li>Basic clothing</li>
                                      <li>
                                        Minimum payments <b
                                          >on your debt, such as credit cards,
                                          student loans, etc</b
                                        >
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <b>30%</b> Toward <b>Wants</b> - This is what
                                    some people think of as the “fun” category. It
                                    includes things you want and would like to
                                    have or do but could probably live without if
                                    you had to. Included as <b>Wants</b> are
                                    things such as
                                    <ul class="how-to-listing">
                                      <li>Date nights</li>
                                      <li>Eating out</li>
                                      <li>
                                        Entertainment (concerts, plays, sporting
                                        events, etc.)
                                      </li>
                                      <li>Gym membership</li>
                                      <li>Hobbies</li>
                                      <li>
                                        Premium and streaming TV (like HBO and
                                        Netflix)
                                      </li>
                                      <li>
                                        Non-essential shopping (new golf clubs, a
                                        new Kate Spade purse, etc.)
                                      </li>
                                      <li>Travel</li>
                                    </ul>
                                  </li>
                                  <li>
                                    <b>20%</b> Toward <b>Financial Goals -</b> The
                                    next number to think about in this budget
                                    formula is 20% toward <b>Financial Goals</b>.
                                    This is the money that goes toward things such
                                    as:
                                    <ul class="how-to-listing">
                                      <li>Building an emergency fund</li>
                                      <li>Paying off high-interest debt</li>
                                      <li>
                                        Higher periodic investment into long-term
                                        accounts
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </b-card>
                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  Brief, Repeat Engagement With MyBudgetReport Is
                                  Critical
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <ul class="how-to-listing">
                                  <li>
                                    Plan to spend a few minutes
                                    with <b>MyBudgetReport</b> a few times per
                                    month to update your known assumptions and to
                                    check-in on your <b
                                      >SPENDiD Budget Health Score</b
                                    > and <b>Predicted Saving Ability</b>.
                                  </li>
                                  <li>
                                    This frequent awareness will help keep you
                                    disciplined in your spending and give you
                                    greater confidence to take potential steps
                                    that are most applicable to YOU.
                                  </li>
                                  <li>
                                    We update our peer database often, which will
                                    reflect in your scores. But also, things
                                    change for you. For example, you'll want to
                                    update MyBudgetReport with changes in your <b
                                      >Take-Home Income</b
                                    >, a <b>Major Fixed Expense</b>, or an
                                    addition to the family!
                                  </li>
                                  <li>
                                    Most importantly, consult with
                                    <b>MyBudgetReport  </b>   <u>before</u> you
                                    make a major expense decision. Try “what-if?”
                                    scenarios you’re considering, such as moving
                                    to a different zip code, purchasing a vehicle,
                                    or taking on a new club membership.
                                  </li>
                                </ul>
                              </div>
                            </b-card>

                            <b-card
                              no-header
                              no-body
                              class="no-box-shadow how-to-page-card how-to-page-card-info mb-3 border-radius-10"
                            >
                              <div class="how-to-page-card-header">
                                <h4 class="how-to-page-header-title m-0">
                                  And Remember <i class="ml-2 far fa-bell"></i>
                                </h4>
                              </div>
                              <div class="how-to-page-card-body">
                                <p class="mb-0">
                                  <b>MyBudgetReport </b> is your “go-to” resource
                                  to help you make smarter and more informed
                                  financial decisions impacting your debt levels
                                  and saving ability. With just a few minutes of
                                  monthly engagement, you can enjoy greater
                                  financial peace of mind, lower stress, and a
                                  healthier and more fulfilling life.
                                </p>
                              </div>
                            </b-card>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
</template>

<script>
    export default {
        name: "howto-app",   
    }
</script>